import { flatMap } from 'lodash';
import { pricingPageV3Query, accountsQuery } from './usePlans';
import { mockPlanStacks } from '@zapier/design-system-revenue/src/mocks';

const accountMock = {
  request: {
    query: accountsQuery,
  },
  result: {
    data: {
      currentUser: {
        id: '173',
        email: 'bill-268@zapier.rodeo',
        fullName: 'j n',
        __typename: 'UserV2',
      },
      accounts: [
        {
          companiesTrialEndDate: null,
          companyAccountEndDate: null,
          companyName: null,
          currentUserRole: 'owner',
          hasBeenInCompaniesTrial: null,
          id: 1,
          isPaying: true,
          isTrialing: false,
          isTrialingTeams: false,
          isTrialingCompanies: false,
          name: "j n's Team",
          owner: {
            __typename: 'AccountOwner',
            id: '173',
            email: 'nill-268@zaper.rodeo',
          },
          plan: {
            id: '1705',
            allowCompanies: false,
            amount: 358800,
            description:
              'Bring your team together to collaborate on automation.',
            features: [
              {
                href: null,
                name: 'Multi-step Zaps',
                tooltip:
                  'Multi-Step Zaps let a single Trigger (e.g. new email lead) perform as many Actions (e.g. add to my CRM) as you want.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Unlimited Premium Apps',
                tooltip:
                  "Premium apps are <a style='color: white; text-decoration: underline' href='/apps/categories/premium' target='_blank'>select apps</a> that are exclusively available to users on a paid plans.",
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Filters',
                tooltip:
                  'Filters tell your Zaps to run only if your data matches certain criteria.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Formatters',
                tooltip:
                  'Formatters let you tweak numbers, dates, and text in over a dozen ways to get it in the format you need.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Custom Integrations',
                tooltip:
                  'Build powerful, custom integrations that connect any app with Webhooks by Zapier.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Custom Logic - Paths',
                tooltip:
                  'Build advanced workflows using branching logic to run different actions based on conditions you decide.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Auto Replay',
                tooltip:
                  'Intelligently retries any Task failures due to temporary errors or downtime for you.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Unlimited Users',
                tooltip:
                  'Add unlimited users to your account at no additional cost.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Folder Permissions',
                tooltip:
                  'Control who can edit shared Zaps and access shared folders.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Premier Support',
                tooltip:
                  'Get faster, prioritized responses from our dedicated Premier Support team.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Shared App Connections',
                tooltip:
                  'Connect your team’s favorite tools, like Trello, Dropbox, or Typeform, so everyone can use them in their workflows without needing to share passwords and API keys.',
                __typename: 'PlanFeature',
              },
              {
                href: null,
                name: 'Shared Workspace',
                tooltip: 'Share access to your Zaps with your team.',
                __typename: 'PlanFeature',
              },
            ],
            hasAutoReplay: true,
            hasPaths: true,
            hasMeteredBilling: false,
            hasMultiStepZaps: true,
            hasPremiumApps: true,
            hasTeams: true,
            interval: 'year',
            isInPlanGroup: true,
            name: 'Team 50k',
            tasks: 50000,
            tiers: [],
            type: 'Team',
            zaps: -1,
            zapsRunInterval: 1,
            __typename: 'PlanV2',
          },
          switches: {
            betaZtCreator: false,
            sharingPrivateSharingEnabled: false,
            sharingPublicSharingEnabled: false,
            sharingGlobalSharingEnabled: false,
            sharingCanEmbedShare: false,
            reportingModule: false,
            googleDomainVerification: false,
            fall2019Pricing: true,
            settingsQuestionnaire: false,
            trackUpgradesByPlan: false,
            taskHistoryUpdate: false,
          },
          teamAccountEndDate: null,
          teamTrialEndDate: null,
          __typename: 'Account',
        },
      ],
    },
  },
};

type Options = {
  // Returns the plans in a flat array, rather than grouped by plan type
  flatPlans?: boolean;
};

const plansMock = ({ flatPlans }: Options = {}) => {
  const planStacks = mockPlanStacks();

  return {
    request: {
      query: pricingPageV3Query,
      variables: {
        accountId: 1,
      },
    },
    result: {
      data: {
        plans: flatPlans
          ? flatMap(planStacks, planStack => planStack.plans)
          : planStacks,
      },
    },
  };
};

export const planMocks = ({ flatPlans }: Options = {}) => [
  accountMock,
  plansMock({ flatPlans }),
];
